import React, { useCallback, useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Nav from '../components/Nav';
import axios from 'axios';
import { endpointApi } from '../utils';
import { setLoading } from '../redux/actions/loader.action';
import { logout } from '../redux/actions/auth.action';
import { getSetting } from '../redux/actions/setting.action';

export default function SettingPage() {
    const jwt_access = localStorage.getItem('jwt_access');
    const { me } = useSelector(state => state.auth);
    const { data } = useSelector(state => state.setting);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const [year, setYear] = useState("");
    const [employeeCode, setEmployeeCode] = useState("");
    const [ramboCode, setRamboCode] = useState("");
    const [bambouCode, setBambouCode] = useState("");
    const [packagingCode, setPackagingCode] = useState("");
    const [productCode, setProductCode] = useState("");
    const [orderCode, setOrderCode] = useState("");
    const [supplierCode, setSupplierCode] = useState("");
    const [clientCode, setClientCode] = useState("");
    const [invoiceCode, setInvoiceCode] = useState("");
    const [delivryNoteCode, setDelivryNoteCode] = useState("");
    const [proformaInvoiceCode, setProformaInvoiceCode] = useState("");
    const [isYearTouched, setIsYearTouched] = useState(false);
    const [isEmployeeCodeTouched, setIsEmployeeCodeTouched] = useState(false);
    const [isRamboCodeTouched, setIsRamboCodeTouched] = useState(false);
    const [isBambouCodeTouched, setIsBambouCodeTouched] = useState(false);
    const [isPackagingCodeTouched, setIsPackagingCodeTouched] = useState(false);
    const [isProductCodeTouched, setIsProductCodeTouched] = useState(false);
    const [isOrderCodeTouched, setIsOrderCodeTouched] = useState(false);
    const [isSupplierCodeTouched, setIsSupplierCodeTouched] = useState(false);
    const [isClientCodeTouched, setIsClientCodeTouched] = useState(false);
    const [isInvoiceCodeTouched, setIsInvoiceCodeTouched] = useState(false);
    const [isDelivryNoteCodeTouched, setIsDelivryNoteCodeTouched] = useState(false);
    const [isProformaInvoiceCodeTouched, setIsProformaInvoiceCodeTouched] = useState(false);
    const [errors, setErrors] = useState(null);

    useEffect(() => {
        dispatch(getSetting(location, navigate));
    }, [location, dispatch, navigate]);
    
    const updateData = useCallback((data) => {
        setYear(data.year);
        setEmployeeCode(data.employee_code);
        setRamboCode(data.rambo_code);
        setBambouCode(data.bambou_code);
        setPackagingCode(data.packaging_code);
        setProductCode(data.product_code);
        setOrderCode(data.order_code);
        setSupplierCode(data.supplier_code);
        setClientCode(data.client_code);
        setInvoiceCode(data.invoice_code);
        setDelivryNoteCode(data.delivry_note_code);
        setProformaInvoiceCode(data.proforma_invoice_code);

        setIsYearTouched(false);
        setIsEmployeeCodeTouched(false);
        setIsRamboCodeTouched(false);
        setIsBambouCodeTouched(false);
        setIsPackagingCodeTouched(false);
        setIsProductCodeTouched(false);
        setIsOrderCodeTouched(false);
        setIsSupplierCodeTouched(false);
        setIsClientCodeTouched(false);
        setIsInvoiceCodeTouched(false);
        setIsDelivryNoteCodeTouched(false);
        setIsProformaInvoiceCodeTouched(false);
    }, []);

    useEffect(() => {
        if(data){
            updateData(data);
        }
    }, [data, updateData]);

    const handleSubmit = async(e) => {
        e.preventDefault();

        if(window.confirm('Voulez-vous vraiment modifier vos paramètres ?')){
            if(window.confirm('Vous êtes sûr ?')){
                const data = new FormData(e.target);
                setErrors(null);
                dispatch(setLoading(true));

                await axios.post(`${ endpointApi }settings`, data, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${ jwt_access }`
                                }            
                            })
                            .then(({ data }) => {
                                updateData(data);
                            })
                            .catch(err => {
                                if(err.response.status === 401){
                                    dispatch(logout(location.pathname + location.search, navigate));
                                }else{
                                    setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                                }
                            })
                            .finally(() => {
                                dispatch(setLoading(false));
                            });
            }
        }
    }

    useEffect(() => {
        if(!jwt_access){
            navigate('/login?redirect_to=' + location.pathname + location.search);
        }
    }, [location, navigate, jwt_access]);

    return (
        me &&
        <HelmetProvider>
            <Helmet>
                <title>Paramètres - Société Mikalo</title>
            </Helmet>

            <Header />

            <Nav />

            <main id="main">
                <div className='title'>
                    <h1>Paramètres</h1>
                </div>
                <div className='box'>
                    <form className='form pt-3 pb-3 pe-4 ps-4' onSubmit={ handleSubmit }>
                        { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                        <h6>Paramètres de numérotation</h6>
                        <div className='row'>
                            <div className='col-12 col-sm-6 col-md-4 mb-3'>
                                <label htmlFor='year' className='required'>Année en exercice</label>
                                <input type='text' minLength={ 4 } maxLength={ 4 } name='year' placeholder='Année en exercice' className='form-control' required autoComplete='off' value={ year } onChange={ (e) => setYear(e.target.value) } onBlur={ () => setIsYearTouched(true) } />
                                { isYearTouched && year.length === 0 && <div className='form-error'>Veuillez saisir l'année en exercice pour gérer automatique le numéro de facture, commande, etc...</div> }
                                { isYearTouched && year.length > 0 && /^[0-9]{4}$/.test(year) === false && <div className='form-error'>Cette valeur n'est pas valide.</div> }
                                { errors && errors.year && <div className='form-error'>{ errors.year[0] }</div> }
                            </div>
                            <div className='col-12 col-sm-6 col-md-4 mb-3'>
                                <label htmlFor='employee_code' className='required'>Numéro de dernier employé</label>
                                <input type='number' min={ 1 } step={ 1 } name='employee_code' placeholder="Numéro de dernier employé" className='form-control' required autoComplete='off' value={ employeeCode } onChange={ (e) => setEmployeeCode(e.target.value) } onBlur={ () => setIsEmployeeCodeTouched(true) } />
                                { isEmployeeCodeTouched && employeeCode.length === 0 && <div className='form-error'>Veuillez saisir le numéro de dernier employé.</div> }
                                { errors && errors.employee_code && <div className='form-error'>{ errors.employee_code[0] }</div> }
                            </div>
                            <div className='col-12 col-sm-6 col-md-4 mb-3'>
                                <label htmlFor='rambo_code' className='required'>Numéro de dernier rambo</label>
                                <input type='number' min={ 1 } step={ 1 } name='rambo_code' placeholder="Numéro de dernier rambo" className='form-control' required autoComplete='off' value={ ramboCode } onChange={ (e) => setRamboCode(e.target.value) } onBlur={ () => setIsRamboCodeTouched(true) } />
                                { isRamboCodeTouched && ramboCode.length === 0 && <div className='form-error'>Veuillez saisir le numéro de dernière matière première.</div> }
                                { errors && errors.rambo_code && <div className='form-error'>{ errors.rambo_code[0] }</div> }
                            </div>
                            <div className='col-12 col-sm-6 col-md-4 mb-3'>
                                <label htmlFor='bambou_code' className='required'>Numéro de dernier bambou</label>
                                <input type='number' min={ 1 } step={ 1 } name='bambou_code' placeholder="Numéro de dernier bambou" className='form-control' required autoComplete='off' value={ bambouCode } onChange={ (e) => setBambouCode(e.target.value) } onBlur={ () => setIsBambouCodeTouched(true) } />
                                { isBambouCodeTouched && bambouCode.length === 0 && <div className='form-error'>Veuillez saisir le numéro de dernière matière première.</div> }
                                { errors && errors.bambou_code && <div className='form-error'>{ errors.bambou_code[0] }</div> }
                            </div>
                            <div className='col-12 col-sm-6 col-md-4 mb-3'>
                                <label htmlFor='packaging_code' className='required'>Numéro de dernier packaging</label>
                                <input type='number' min={ 1 } step={ 1 } name='packaging_code' placeholder="Numéro de dernier packaging" className='form-control' required autoComplete='off' value={ packagingCode } onChange={ (e) => setPackagingCode(e.target.value) } onBlur={ () => setIsPackagingCodeTouched(true) } />
                                { isPackagingCodeTouched && packagingCode.length === 0 && <div className='form-error'>Veuillez saisir le numéro de dernier packaging.</div> }
                                { errors && errors.packaging_code && <div className='form-error'>{ errors.packaging_code[0] }</div> }
                            </div>
                            <div className='col-12 col-sm-6 col-md-4 mb-3'>
                                <label htmlFor='product_code' className='required'>Numéro de dernier produit</label>
                                <input type='number' min={ 1 } step={ 1 } name='product_code' placeholder="Numéro de dernier produit" className='form-control' required autoComplete='off' value={ productCode } onChange={ (e) => setProductCode(e.target.value) } onBlur={ () => setIsProductCodeTouched(true) } />
                                { isProductCodeTouched && productCode.length === 0 && <div className='form-error'>Veuillez saisir le numéro de dernier produit.</div> }
                                { errors && errors.product_code && <div className='form-error'>{ errors.product_code[0] }</div> }
                            </div>
                            <div className='col-12 col-sm-6 col-md-4 mb-3'>
                                <label htmlFor='order_code' className='required'>Numéro de dernière commande</label>
                                <input type='number' min={ 1 } step={ 1 } name='order_code' placeholder="Numéro de dernière commande" className='form-control' required autoComplete='off' value={ orderCode } onChange={ (e) => setOrderCode(e.target.value) } onBlur={ () => setIsOrderCodeTouched(true) } />
                                { isOrderCodeTouched && orderCode.length === 0 && <div className='form-error'>Veuillez saisir le numéro de dernière commande.</div> }
                                { errors && errors.order_code && <div className='form-error'>{ errors.order_code[0] }</div> }
                            </div>
                            <div className='col-12 col-sm-6 col-md-4 mb-3'>
                                <label htmlFor='supplier_code' className='required'>Numéro de dernier fournisseur</label>
                                <input type='number' min={ 1 } step={ 1 } name='supplier_code' placeholder="Numéro de dernier fournisseur" className='form-control' required autoComplete='off' value={ supplierCode } onChange={ (e) => setSupplierCode(e.target.value) } onBlur={ () => setIsSupplierCodeTouched(true) } />
                                { isSupplierCodeTouched && supplierCode.length === 0 && <div className='form-error'>Veuillez saisir le numéro de dernier fournisseur.</div> }
                                { errors && errors.supplier_code && <div className='form-error'>{ errors.supplier_code[0] }</div> }
                            </div>
                            <div className='col-12 col-sm-6 col-md-4 mb-3'>
                                <label htmlFor='client_code' className='required'>Numéro de dernier client</label>
                                <input type='number' min={ 1 } step={ 1 } name='client_code' placeholder="Numéro de dernier client" className='form-control' required autoComplete='off' value={ clientCode } onChange={ (e) => setClientCode(e.target.value) } onBlur={ () => setIsClientCodeTouched(true) } />
                                { isClientCodeTouched && clientCode.length === 0 && <div className='form-error'>Veuillez saisir le numéro de dernier client.</div> }
                                { errors && errors.client_code && <div className='form-error'>{ errors.client_code[0] }</div> }
                            </div>
                            <div className='col-12 col-sm-6 col-md-4 mb-3'>
                                <label htmlFor='invoice_code' className='required'>Numéro de dernière facture</label>
                                <input type='number' min={ 1 } step={ 1 } name='invoice_code' placeholder="Numéro de dernière facture" className='form-control' required autoComplete='off' value={ invoiceCode } onChange={ (e) => setInvoiceCode(e.target.value) } onBlur={ () => setIsInvoiceCodeTouched(true) } />
                                { isInvoiceCodeTouched && invoiceCode.length === 0 && <div className='form-error'>Veuillez saisir le numéro de dernière facture.</div> }
                                { errors && errors.invoice_code && <div className='form-error'>{ errors.invoice_code[0] }</div> }
                            </div>
                            <div className='col-12 col-sm-6 col-md-4 mb-3'>
                                <label htmlFor='delivry_note_code' className='required'>Numéro de dernier bon de livraison</label>
                                <input type='number' min={ 1 } step={ 1 } name='delivry_note_code' placeholder="Numéro de dernier bon de livraison" className='form-control' required autoComplete='off' value={ delivryNoteCode } onChange={ (e) => setDelivryNoteCode(e.target.value) } onBlur={ () => setIsDelivryNoteCodeTouched(true) } />
                                { isDelivryNoteCodeTouched && delivryNoteCode.length === 0 && <div className='form-error'>Veuillez saisir le numéro de dernier bon de livraison.</div> }
                                { errors && errors.delivry_note_code && <div className='form-error'>{ errors.delivry_note_code[0] }</div> }
                            </div>
                            <div className='col-12 col-sm-6 col-md-4 mb-3'>
                                <label htmlFor='proforma_invoice_code' className='required'>Numéro de dernière facture proforma</label>
                                <input type='number' min={ 1 } step={ 1 } name='proforma_invoice_code' placeholder="Numéro de dernière facture proforma" className='form-control' required autoComplete='off' value={ proformaInvoiceCode } onChange={ (e) => setProformaInvoiceCode(e.target.value) } onBlur={ () => setIsProformaInvoiceCodeTouched(true) } />
                                { isProformaInvoiceCodeTouched && proformaInvoiceCode.length === 0 && <div className='form-error'>Veuillez saisir le numéro de dernière facture proforma.</div> }
                                { errors && errors.proforma_invoice_code && <div className='form-error'>{ errors.proforma_invoice_code[0] }</div> }
                            </div>
                        </div>
                        <div className='pt-2 text-end'>
                            <button type='submit' className='btn btn-lg btn-primary'><i className="fa fa-save"></i> Enregistrer</button>
                        </div>
                    </form>
                </div>
            </main>
        </HelmetProvider>
    )
}
